import { BackgroundAnimation, ArticleModel, Domrefs } from "./types";

const getPositionAlongTheLine = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  percentage: number
) => {
  //https://stackoverflow.com/a/57383437
  return {
    x: x1 * (1.0 - percentage) + x2 * percentage,
    y: y1 * (1.0 - percentage) + y2 * percentage,
  };
  /*Example */
  /* var xy = getPositionAlongTheLine(100, 200, 500, 666, 0.5);
	console.log(xy.x, xy.y); */
};

const getDefaultBackgroundAnimationSettings = (): BackgroundAnimation => {
  return {
    duration: 1,
    delay: 0,
    id: "none",
    tyyppi: "alusta_alkava",
    start: {
      scale: 1,
      translate: { x: 0, y: 0 },
    },
    end: {
      scale: 1,
      translate: { x: 0, y: 0 },
    },
  };
};

const createIntersectionObserver = (cb): IntersectionObserver => {
  let callback = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        cb(entry.target);
      }
    });
  };
  return new IntersectionObserver(callback, {});
};

const getDOMRefs = (): Domrefs => ({
  TEKSTILAATIKOT: document.querySelectorAll(".skrollattava-laatikko"),
  SISALTO: document.getElementById("sisalto"),
  TAUSTAKANGAS: document.getElementById("taustakangas"),
  AIKAJANA: document.getElementById("aikajana"),
  LOTTIE: document.getElementById("lottie-animation"),
  OTSIKKO: document.getElementById("punainen-lista-metsa-header"),
  LOPPUARTIKKELI: document.getElementById("loppuartikkeli"),
  NAPPI: document.getElementById("tervetuloa-nappi"),
  APPCONTAINER: document.getElementById("app-container"),
});

let gsap;
const loadGSAP = async () => {
  if (!gsap) {
    gsap = await import("gsap");
    console.log("gsap loaded");
    return gsap.gsap
} else {
  return gsap.gsap;
  }
};

let lottiejs;
const loadLottie = async () => {
  if (!lottiejs) {
    lottiejs = await import("@lottiefiles/lottie-player");
    console.log("lottie loaded");
  }
  return true;
};

// Set CSS `tranform` property for an element
function setTransform(el: HTMLElement, transform: string) {
  el.style.transform = transform;
  el.style.webkitTransform = transform;
}

export {
  getPositionAlongTheLine,
  getDefaultBackgroundAnimationSettings,
  createIntersectionObserver,
  getDOMRefs,
  loadLottie,
  setTransform,
  loadGSAP,
};
